var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fixed-header',{attrs:{"threshold":_vm.threshold},on:{"change":_vm.updateFixedStatus}},[_c('div',[_c('div',{staticClass:"header"},[_c('main-container',[_c('header-logo',{attrs:{"small":_vm.sticky}}),_c('div',{staticClass:"menu-container"},[_c('public-menu',{attrs:{"menu":_vm.menuItems}})],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }